<div class="baa-flow-container flex flex-col overflow-y-auto">
  <div
    class="container mt-3 flex justify-center px-10 xs:justify-start"
    [class.items-start]="service.viewSignal() === 'decision'"
    [class.items-center]="service.viewSignal() !== 'decision'"
  >
    <img class="h-[48px]" src="assets/images/notes-logo-header.svg" height="48" alt="FFD Notes" />
  </div>

  @if (service.isInitializingSignal()) {
    <div class="flex flex-1 items-center justify-center">
      <ng-lottie [options]="lottieOptions" currentColor class="text-primary-blue" />
    </div>
  } @else {
    @if (service.viewSignal() === 'decision') {
      @if (service.activeRequestSignal()?.kind === 'invitation') {
        <lib-ffd-notes-invite-decision class="flex flex-1 flex-col" />
      } @else {
        <lib-baa-request-decision class="flex flex-1 flex-col" />
      }
    } @else {
      <lib-baa-request-list />
    }
  }
</div>
